module.exports = __webpack_public_path__ + "img/El-Terrible-mobile.9c8a42ec.jpg";